module.exports = __webpack_public_path__ + "media/图1-27动画.8055a5ea.mp4";